module.exports = __webpack_public_path__ + "img/flow_icon03.20f12bfe.png";